import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/models/promotionDecision';
import { getModelDetail } from '../../actions/models/detail';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  const { modelId, decision } = action?.payload || {};
  try {
    const response = yield call(
      axios.post,
      `${config.API_URL}/pipelines/${modelId}/promotion-decision`,
      { action: decision },
      {
        headers: {
          ...getLocalUser(),
          'X-Workspace-Id': localStorage.getItem('WORKSPACE_ID') || '',
        },
      },
    );
    // Echo the decision so the component can pick the right fallback
    // success message when the backend doesn't send one.
    yield put(fetchSuccess({
      decision,
      result: response?.data?.data ?? null,
    }));
    // Refresh the pipeline header + trainings so the resolved
    // promotion banner disappears immediately.
    yield put(getModelDetail(modelId, { trainings_page: 0, trainings_per_page: 20 }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
